/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
// import MKSocialButton from "components/MKSocialButton";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
// import DefaultFooter from "examples/Footers/DefaultFooter";
import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";

// Presentation page sections
import Counters from "pages/Presentation/sections/Counters";
import Information from "pages/Presentation/sections/Information";
// import DesignBlocks from "pages/Presentation/sections/DesignBlocks";
// import Pages from "pages/Presentation/sections/Pages";
import Testimonials from "pages/Presentation/sections/Testimonials";
// import Download from "pages/Presentation/sections/Download";

// Presentation page components
// import BuiltByDevelopers from "pages/Presentation/components/BuiltByDevelopers";

// Routes
import routes from "routes";
// import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/beninvi0.png";

function Presentation() {
  return (
    <>
      <DefaultNavbar
        routes={routes}
        sticky
      />
      <MKBox
        minHeight="75vh"
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "top",
          display: "grid",
          placeItems: "center",
          color: "#C80003",
          backgroundColor: "#F5F5F5",
        }}
      >
        <Container backgroundColor="#F5F5F5">
          <Grid container item xs={12} lg={7} justifyContent="center" mx="auto" backgroundColor="#F5F5F5">
            <MKTypography
              variant="h1"
              color="#C80003"
              backgroundColor="#F5F5F5"
              mt={-6}
              mb={1}
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              BENINVI{" "}
            </MKTypography>
            <MKTypography
              variant="body1"
              color="#C80003"
              backgroundColor="#F5F5F5"
              textAlign="center"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >
                    Parce ce que la jeune la fille est la prunelle du monde.
                    Parce que l&apos;enfant est précieux.      
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
      <MKBox sx={{ backgroundColor: "#F5F5F5", p: 2 }}>
        <Card
          sx={{
            p: 2,
            mx: { xs: 2, lg: 3 },
            mt: -8,
            mb: 4,
            backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
            backdropFilter: "saturate(200%) blur(30px)",
            boxShadow: ({ boxShadows: { xxl } }) => xxl,
          }}
        >
          <Counters />
          <Information />
          {/* <DesignBlocks /> */}
          {/* <Pages /> */}
          {/* <Container sx={{ mt: 6 }}>
            <BuiltByDevelopers />
          </Container> */}
          <Container>
            {/* <Grid container spacing={3}>
              <Grid item xs={12} lg={4}>
                <FilledInfoCard
                  variant="gradient"
                  color="info"
                  icon="flag"
                  title="Commencer"
                  description="Découvrez les différentes façons de travailler avec notre produit et les fichiers nécessaires pour créer votre propre projet."
                  action={{
                    type: "external",
                    route: "https://www.creative-tim.com/learning-lab/react/overview/material-kit/",
                    label: "Commençons",
                  }}
                />
              </Grid>
              <Grid item xs={12} lg={4}>
                <FilledInfoCard
                  color="info"
                  icon="precision_manufacturing"
                  title="Plugins"
                  description="Trouvez l'inspiration et obtenez un aperçu des plugins que nous avons utilisés pour créer le Kit Material."
                  action={{
                    type: "external",
                    route: "https://www.creative-tim.com/learning-lab/react/overview/datepicker/",
                    label: "En savoir plus",
                  }}
                />
              </Grid>
              <Grid item xs={12} lg={4}>
                <FilledInfoCard
                  color="info"
                  icon="apps"
                  title="Composants"
                  description="Material Kit vous offre de nombreux composants préfabriqués, qui vous aideront à créer des interfaces utilisateur plus rapidement."
                  action={{
                    type: "external",
                    route: "https://www.creative-tim.com/learning-lab/react/alerts/material-kit/",
                    label: "En savoir plus",
                  }}
                />
              </Grid>
            </Grid> */}
            <Grid container spacing={3}>
  <Grid item xs={12} lg={4}>
    <FilledInfoCard
      variant="gradient"
      color="info"
      icon="volunteer_activism"
      title="Notre Mission"
      description="BENINVI œuvre pour l'éducation, l'autonomie et l'émancipation des filles et des enfants au Bénin. Découvrez nos actions et engagements."
      action={{
        type: "external",
        route: "#mission",
        label: "En savoir plus",
      }}
    />
  </Grid>
  <Grid item xs={12} lg={4}>
    <FilledInfoCard
      color="info"
      icon="school"
      title="Programmes Éducatifs"
      description="Awhilivou et Ovi vè sont nos initiatives pour soutenir l'éducation et l'insertion des jeunes filles et enfants non scolarisés."
      action={{
        type: "external",
        route: "#programmes",
        label: "Découvrir",
      }}
    />
  </Grid>
  <Grid item xs={12} lg={4}>
    <FilledInfoCard
      color="info"
      icon="groups"
      title="Rejoignez-nous"
      description="Participez à nos actions en devenant bénévole, en apportant votre soutien ou en établissant un partenariat avec nous."
      action={{
        type: "external",
        route: "#rejoindre",
        label: "Nous contacter",
      }}
    />
  </Grid>
</Grid>

          </Container>
          <Testimonials />
          {/* <Download /> */}
          {/* <MKBox pt={18} pb={6}>
            <Container>
              <Grid container spacing={3}>
                <Grid item xs={12} lg={5} ml="auto" sx={{ textAlign: { xs: "center", lg: "left" } }}>
                  <MKTypography variant="h4" fontWeight="bold" mb={0.5}>
                    Merci pour votre soutien!
                  </MKTypography>
                  <MKTypography variant="body1" color="text">
                    Nous livrons les meilleurs produits web
                  </MKTypography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  lg={5}
                  my={{ xs: 5, lg: "auto" }}
                  mr={{ xs: 0, lg: "auto" }}
                  sx={{ textAlign: { xs: "center", lg: "right" } }}
                >
                  <MKSocialButton
                    component="a"
                    href="https://twitter.com/intent/tweet?text=Découvrez%20BENINVI%20%23autonomiedesfemmes%20%23égalitédugenre%20%23éducation%20%23luttetravaildesenfants&amp;url=https%3A%2F%2Fwww.beninvi.org"
                    target="_blank"
                    color="twitter"
                    sx={{ mr: 1 }}
                  >
                    <i className="fab fa-twitter" />
                    &nbsp;Tweet
                  </MKSocialButton>
                  <MKSocialButton
                    component="a"
                    href="https://www.facebook.com/sharer/sharer.php?u=https://www.beninvi.org"
                    target="_blank"
                    color="facebook"
                    sx={{ mr: 1 }}
                  >
                    <i className="fab fa-facebook" />
                    &nbsp;Partager
                  </MKSocialButton>
                  <MKSocialButton
                    component="a"
                    href="https://www.pinterest.com/pin/create/button/?url=https://www.beninvi.org"
                    target="_blank"
                    color="pinterest"
                  >
                    <i className="fab fa-pinterest" />
                    &nbsp;Épingler
                  </MKSocialButton>
                </Grid>
              </Grid>
            </Container>
          </MKBox> */}
        </Card>
      </MKBox>
      <MKBox pt={6} px={1} mt={6}>
        {/* <DefaultFooter content={footerRoutes} /> */}
      </MKBox>
    </>
  );
}

export default Presentation;
